<template>
  <aside
    class="page-navigation">
    <div class="page-navigation__heading ucase grey">
      <h3>
        Site Navigation
      </h3>
    </div>
    <div class="page-navigation__menu">
      <ul
        v-if="menuItems"
        class="page-navigation__menu-main">
        <li
          v-for="(menuItem, key) in menuItems"
          :key="`menuItem${key}`">
          <RouterLink
            :to="menuItem.path"
            class="bold">
            {{ menuItem.meta.navPrepend }} {{ menuItem.name }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'PageNavigation',
  components: {
  },
  data() {
    return {
      menuActive: false,
      sectionItems: [],
      activeSectionItem: 0,
      rows: null
    }
  },
  computed: {
    menuItems: function() {
      return this.$router.options.routes.filter(route => {
        if (route.meta.showInMenu) return true
      })
    }
  },
  watch: {
    $route(to, from) {
     if(this.menuActive) {
       this.menuActive = false;
     }
     this.rows = null
    }
  },
  mounted() {
    this.$root.$on('sectionsList', (sections) => {
      this.sectionItems = sections
      this.activeSectionItem = 0

      setTimeout(() => {
        this.rows = document.querySelectorAll('.row')

        window.addEventListener('scroll', ($evt) => {
          if (this.rows) {
            if (this.rows[this.activeSectionItem] && (this.rows[this.activeSectionItem].getBoundingClientRect().top - 160) < 0) {
              this.activeSectionItem = this.activeSectionItem < this.rows.length - 1 ? this.activeSectionItem + 1 : this.rows.length - 1
            }

            if (this.rows[this.activeSectionItem] && (this.rows[this.activeSectionItem].getBoundingClientRect().top - 160) > 0) {
              this.activeSectionItem = this.activeSectionItem > 0 ? this.activeSectionItem - 1 : 0
            }
          }

        })
      }, 300)
    })
  },
  methods: {
    toggleMenu: function() {
      if (this.menuActive === false) {
        this.menuActive = true
      }
    },
    scrollTo(target, key) {
      // get target element and header height for offset
      var element = document.getElementById(target)
      var offset = document.querySelector('.header').offsetHeight

      // get body height to reference against element
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = element.getBoundingClientRect().top

      // calculate element scroll position
      const elementPosition = elementRect - bodyRect

      // subtract header offset height
      const offsetPosition = elementPosition - offset

      // check if element exists
      if(element) {
        // close menu
        this.menuActive = false;

        // scroll to elements position
        window.scrollTo({
            top: offsetPosition,
            behavior: "auto"
        });

        this.activeSectionItem = key
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-navigation {
  width:100%;
  margin:100px 0;
  display: flex;
  align-content: center;
  background: $color--base;
  padding: 30px 0;
  backface-visibility: hidden;
  z-index: 3;

  @include mobile {
    padding: $gutter--base $gutter--base-mbl;
  }

  &__heading {
    width:50%;
  }

  &__menu {
    width:50%;
    position: relative;
    background: $color--base;
    // padding: 0 $gutter--base;
    backface-visibility: hidden;
    display: flex;

    @include mobile {
      flex-direction: column;
      padding: 0 15px;
    }

    ul {
      // padding-top: $gutter--base;

      &.header__menu-main {
        margin-right: rem(80);
        min-width: 29.5vw;

        @include mobile {
          margin-right: 0;
        }

        @include desktop {
          min-width: rem(363);
        }

        > li:nth-child(2) {
          margin-bottom: rem(40);

          @include mobile {
            margin-bottom: rem(20);
          }
        }
      }

      &.header__menu-sections {
        a,
        button {
          color: $color--grey;
        }

        @include mobile {
          display: none;
        }
      }

      li {
        &:nth-child(2) {
          margin: 0 0 2.5rem 0;
        }
      }
    }

    button {
      @include button-resets;
    }

    a, button {
      color: $color--grey;
      @include text-large;

      &.router-link-exact-active {
        color: $color--white;
      }
    }
  }
}
</style>
